/* eslint-disable */
import getPeopleDetailByUin from './getPeopleDetailByUin';
import getMixFaceByUin from './getMixFaceByUin';
import getTroopDetailById from './getTroopDetailByIdForTroop';
import getGQQPeopleDetailByUin from './getGQQPeopleDetailByUin';
import getGtroopDetailById from './getGtroopDetailByIdForTroop';
import getDetailByReload from './getDetailByReload';
 
// 这个方法是为了兼容 部分数据源从 jsBrige 向 ajax 转换的过程
function checkAjax(config, type) {
    let isAjax = false;
    if (config && config[type] && config[type].ajax) {
        isAjax = true;
    }
    return isAjax;
}

export default function(config) {
    return {
        troop: getTroopDetailById,
        QQFriend: getPeopleDetailByUin,
        colleague: checkAjax(config, 'colleague') ? null : getPeopleDetailByUin,
        groupChatMember: getPeopleDetailByUin,
        troopMember: getPeopleDetailByUin,
        discussMember: getPeopleDetailByUin,
        cloudPhoneBook: checkAjax(config, 'cloudPhoneBook') ? null : getPeopleDetailByUin,
        customer: getPeopleDetailByUin,
        discuss: null,
        recent: getMixFaceByUin,
        result: getDetailByReload,
        GQQFriend: getGQQPeopleDetailByUin,
        Gtroop: getGtroopDetailById
    };
}
